module.exports = __webpack_public_path__ + "media/Images/why-choose-us-header-image-157a9e211b7d8b40850cc61cb0942f15.jpg";